import { render, staticRenderFns } from "./MessageDialog.vue?vue&type=template&id=8fa5418c"
import script from "./MessageDialog.vue?vue&type=script&lang=js"
export * from "./MessageDialog.vue?vue&type=script&lang=js"
import style0 from "./MessageDialog.vue?vue&type=style&index=0&id=8fa5418c&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports